import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { ThunkDispatch } from "redux-thunk";

import CssBaseline from '@material-ui/core/CssBaseline';

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import yellow from '@material-ui/core/colors/amber';
import lightGreen from '@material-ui/core/colors/lightGreen';

import { showCreateNoteDialog, Action, helpPanelDragging, stopHelpPanelDragging } from "../actions";
import {
    getError,
    getHelpPanelState,
    getLocale,
    getNoteDialogState,
    getNoteDragging,
    getProcessStep,
    getSlideDragging,
    getTimeDialogState,
    State
} from '../reducers';

import MainLayout from '../components/MainLayout';
import { NoteColor, ProcessStep } from "../constants";
import { getTranslations, Locale } from "../services/translation-store";
import SentryErrorBoundary from "../components/SentryErrorBoundary";


interface StateProps {
    readonly processStep: ProcessStep,
    readonly captureMouse: boolean,
    readonly keyboardEnabled: boolean,
    readonly error: Error | null,
    readonly locale: Locale,
    readonly translationsForLocale: { [id: string]: string },
}

interface DispatchProps {
    readonly onRegularKeyPressed: () => void,
    readonly onMouseMove: (x: number, y: number) => void,
    readonly onMouseUp: (x: number, y: number) => void,
}

type Props = StateProps & DispatchProps;

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: lightGreen,
        secondary: yellow,
    },
});

const mapStateToProps = (state: State): StateProps => {
    const processStep = getProcessStep(state);
    const locale = getLocale(state);
    const captureMouse = getHelpPanelState(state).dragging;
    return {
        processStep,
        captureMouse,

        keyboardEnabled:
            (processStep === ProcessStep.BRAINSTORM || processStep === ProcessStep.STRUCTURE)
            && !getNoteDialogState(state).open
            && !getTimeDialogState(state).open
            && getNoteDragging(state) === null
            && getSlideDragging(state) === null,

        error: getError(state),
        locale,
        translationsForLocale: getTranslations(locale),
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onRegularKeyPressed: () => {
            dispatch(showCreateNoteDialog(NoteColor.YELLOW))
        },
        onMouseMove: (x) => {
            dispatch(helpPanelDragging(1 - x));
        },
        onMouseUp: (x) => {
            dispatch(stopHelpPanelDragging(1 - x));
        },
    }
);

const App = ({keyboardEnabled, processStep, captureMouse, error, onRegularKeyPressed, onMouseMove, onMouseUp, locale, translationsForLocale}: Props) => (
    <IntlProvider
        key={locale}
        locale={locale}
        messages={translationsForLocale}
    >
        <MuiThemeProvider theme={theme}>
            <CssBaseline/>
            <SentryErrorBoundary error={error}>
                <MainLayout processStep={processStep}
                            captureMouse={captureMouse}
                            onRegularKeyPressed={keyboardEnabled ? onRegularKeyPressed : undefined}
                            onMouseMove={onMouseMove}
                            onMouseUp={onMouseUp}
                />
            </SentryErrorBoundary>
        </MuiThemeProvider>
    </IntlProvider>
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);


// WEBPACK FOOTER //
// ./src/containers/App.tsx